import { FC } from 'react';
import xor from 'lodash-es/xor';

import { JabraCheckbox, useFallbackTranslation } from '@gn-audio/jss-components';
import { Group, ProductType } from '@gn-audio/jss-core';

import { WithPrice } from 'api/pricesApi/pricesModel';
import { Price } from 'composables/Product/Buy/Price/Price';

export interface AccessoriesProps {
  accessories: WithPrice<Group>[];
  selectedAccessoryIds: number[];
  onSelectedAccessoriesChange?: (accessories: number[]) => void;
}

export const AccessoriesPicker: FC<AccessoriesProps> = ({
  accessories,
  selectedAccessoryIds,
  onSelectedAccessoriesChange,
}) => {
  const { t } = useFallbackTranslation();

  const handleToggleAccessory = (productId: number) => {
    const newSelectedAccessoryIds = xor(selectedAccessoryIds, [productId]);
    onSelectedAccessoriesChange && onSelectedAccessoriesChange(newSelectedAccessoryIds);
  };
  return (
    <div>
      <h2 className="pb-3 text-[1.125rem] font-bold text-gray-700">
        {t('system.CustomizerAccessoriesHeadline')}
      </h2>
      <ul className="flex flex-col gap-5">
        {accessories?.map(({ product, price }) => {
          const selected = selectedAccessoryIds.includes(product.productId);
          return (
            <li key={product.productId}>
              <label className="light flex cursor-pointer items-center gap-4 overflow-hidden rounded-md bg-infographicBgGrey1 p-6">
                <JabraCheckbox
                  checked={selected}
                  onCheckedChange={() => handleToggleAccessory(product.productId)}
                />
                <img
                  src={product.thumbnailUrl}
                  className="h-[8.125rem] w-[8.125rem] select-none"
                  alt={product.productName}
                />
                <span>
                  <h3 className="mb-4 text-[1.125rem] font-bold text-gray-700">
                    {product.productName}
                  </h3>
                  <Price
                    className="text-gray-700"
                    productType={ProductType.Product}
                    segmentType={product.segmentType}
                    price={price}
                  />
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
